import { useRef, useState } from "react";
import { Mic, Square } from "lucide-react";
import { toast } from "sonner";
import { t } from "@/i18n";

export function AudioRecorder({ onRecorded }) {
  const [rec, setRec] = useState(null);
  const chunks = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      chunks.current = [];
      mr.ondataavailable = (e) => chunks.current.push(e.data);
      mr.onstop = () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunks.current, { type: "audio/webm" });
        onRecorded(new File([blob], `voice-note-${Date.now()}.webm`, { type: "audio/webm" }));
      };
      mr.start();
      setRec(mr);
    } catch {
      toast.error(t("Microphone not available in this browser"));
    }
  };
  const stop = () => { rec.stop(); setRec(null); };

  return rec ? (
    <button type="button" className="btn btn-ghost btn-sm !border-[var(--status-error)]" onClick={stop} data-testid="capture-record-stop-button">
      <Square size={14} className="text-[var(--status-error)]" /> {t("Stop recording")} <span className="pulse-dot text-[var(--status-error)]">●</span>
    </button>
  ) : (
    <button type="button" className="btn btn-ghost btn-sm" onClick={start} data-testid="capture-record-start-button">
      <Mic size={14} /> {t("Record voice note")}
    </button>
  );
}
